import styled from 'styled-components'
import { fadeIn } from '../../styles/keyframes'
import { invert, transparentize } from 'polished'
// @ts-ignore
import * as theme from 'styled-theming'

const colors = {
  background: theme('mode', {
    light: (props: any) => transparentize(0.25, invert(props.theme.color.black)),
    dark: (props: any) => transparentize(0.25, props.theme.color.black),
  }),
}

export const Overlay = styled.aside`
  animation: ${fadeIn} 100ms ease-in-out;
  background-color: ${colors.background};
  bottom: 0;
  left: 0;
  height: 100%;
  overflow-y: auto;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/Overlay/index.tsx